import { Box, type BoxProps } from '@chakra-ui/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type FC, type ReactNode } from 'react';

interface Props extends BoxProps {
  children: ReactNode;
  id: string;
  isDisabled?: boolean;
}

export const SortableItem: FC<Props> = ({
  id,
  children,
  isDisabled = false,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: isDisabled });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    touchAction: 'none',
  };
  return (
    <Box
      ref={setNodeRef}
      zIndex={isDragging ? 2 : 0}
      style={style}
      {...props}
      {...attributes}
      {...listeners}
    >
      {children}
    </Box>
  );
};
